module.exports = __webpack_public_path__ + "item_5.svg?5e8b01d1a6f971def9ef1f04548da1c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item_5.svg
// module id = 28
// module chunks = 0